
import * as D from '../data-utils';


  import App from '../app';
  import './Constants';
  import Events from '../events';
  import Map from './Map';
  import Wayfinding from './Wayfinding';
  import './Storelist';
  import './TipsAndBenefits';
  import './EventsAndNews';

  var data = {};

  var context;
  function init(appContext){

    context = appContext;
    resetFiltering();

    var disabledLanguages = context.disabledLanguages;
    var translations = D.translations();
    var scdata = D.scdata();
    var stores = D.storelist();
    var imddata = Map.getImdData(context);
    var storedata = Map.getStoreData(imddata.floorIndex);
    var scimddata = getShoppingCenterImdData();
    Wayfinding.init(scimddata, imddata, context);
    var startNodes = getStartNodes(imddata);
    const { mapType, scid, feature } = context.imdSettings;

    data = {
      'scdata': scdata,
      'langs': D.langs(),
      'currentLang': D.lang(),
      'disabledLanguages': disabledLanguages,
      mapType,
      menu: getMenu(context),
      scid,
      'stores': stores.stores,
      'storedata': storedata,
      'scimddata': scimddata,
      'imddata': imddata,
      'imd': getImdData(),
      'startNodes': startNodes,
      'translations': translations,
      'iconsvg': context.resources.get('im_info'),
      'imdHash': context.imdHash,
      'scName': context.scName || '',
      'classBasedOnNumberOfFeatures': getClassBasedOnNumberOfFeatures(feature)
    };
    return data;
  }

  function getData(){
    return data;
  }

  function getStartNodes(imddata){
    var startPosition = { x: imddata.x, y: imddata.y, floorIndex: imddata.floorIndex };
    var floorIndex = imddata.floorIndex;
    var startNodes = Wayfinding.drawStartNodes(floorIndex, startPosition);
    return startNodes;
  }

  function getShoppingCenterImdData(){
    return D.scimddata();
  }

  function getImdData(imdID){
    const {imds} = getShoppingCenterImdData();
    const imd = imds.find(imd => imd.id == context.imdId);

    return imd;
  }

  function getClassBasedOnNumberOfFeatures(feature) {
    const minorFeatures = [
      'eventsAndNews', 'tipsAndBenefits', 'openingHours', 'lunchMenu'
    ];
    const numberOfFeatures = minorFeatures.reduce(
      (acc, name) => feature[name] ? acc + 1 : acc, // append if feature is on
      context.maxFeatureLifts || 0 // Use as initial value
    );

    return `minor-links-count-${numberOfFeatures}`;
  }

  function featureSlotsAvailable(thirdPartyLinks) {
    return thirdPartyLinks.length == context.maxFeatureLifts;
  }

  function getFeatureLifts(thirdPartyLinks) {
    let featureLifts;

    if (featureSlotsAvailable(thirdPartyLinks)) {
      featureLifts = thirdPartyLinks;

      featureLifts.forEach(lift => {
        lift.iconUrl = lift.iconUrl || '/app/imd/dist/sprite.stack.svg#' + lift.icon;
      });
    }

    return featureLifts;
  }

  const getMenu = context => Object.assign(
    Object.entries({
      stores: '#list',
      tipsAndBenefits: '#tips',
      eventsAndNews: '#news',
      search: '#search',
      locations: '#maps',
      openingHours: '#hours',
      lunchMenu: '#lunchmenu'
    }).reduce((acc, [k,v]) => {
      acc[k] = context.imdSettings.feature[k] && v;
      return acc;
    }, {}),
    {
      more: context.thirdPartyLinks,
      featureLifts: getFeatureLifts(context.thirdPartyLinks)
    }
  );

  function goTo(hash){
    window.location.href=hash;
  }

  function goToThirdPartyLink(index) {
    Events.dispatchEvent(
      '3rd-party:open', context.thirdPartyLinks[index]
    );
    App.saveLocally({value: index}, 'ThirdPartyLinkIndex', 'all');
    goTo('#thirdparty');
  }

  function refreshLanguage(){
    data.currentLang = D.lang();
  }

  function resetFiltering(){
    App.removeStoredData('currentStorelist', 'all');
    App.removeStoredData('currentLunchMenu', 'all');
    App.removeStoredData('currentStore', 'all');
    App.removeStoredData('currentOfferdata', 'all');
  }

  export default  {
    init,
    getData,
    getMenu,
    goTo,
    refreshLanguage,
    goToThirdPartyLink
  };

